"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
exports.__esModule = true;
exports.default = void 0;
var _styledComponents = require("styled-components");
var _consts = _interopRequireDefault(require("../consts"));
var _rtl = require("../../utils/rtl");
const getPosition = ({
  position,
  theme
}) => (0, _styledComponents.css)(["", ":0;"], position === _consts.default.RIGHT ? (0, _rtl.right)({
  theme
}) : (0, _rtl.left)({
  theme
}));
var _default = getPosition;
exports.default = _default;